<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.7827 7.29939H7.77271V5.49939C7.77271 5.05939 7.23271 4.82939 6.92271 5.14939L4.14272 7.93939C3.95272 8.13939 3.95272 8.44939 4.14272 8.64939L6.92271 11.4394C7.23271 11.7594 7.77271 11.5394 7.77271 11.0894V9.29939H18.7827C19.3327 9.29939 19.7827 8.84939 19.7827 8.29939C19.7827 7.74939 19.3327 7.29939 18.7827 7.29939ZM5 14.7093H16.01V12.9093C16.01 12.4693 16.55 12.2393 16.86 12.5593L19.64 15.3493C19.83 15.5493 19.83 15.8593 19.64 16.0593L16.86 18.8493C16.55 19.1693 16.01 18.9493 16.01 18.4993V16.7093H5C4.45 16.7093 4 16.2593 4 15.7093C4 15.1593 4.45 14.7093 5 14.7093Z"
    fill="currentColor"
  />
</svg>
